export const debounce = (fn: (args?: any) => void, delayInMs: number) => {
  let timer;
  return function (...args) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn(...args);
    }, delayInMs);
  };
};
